import type { AreaCatalog } from '../area';
import type { boards as en } from '../en/boards';

export const boards = {
  // --- The head ---
  'boards.page.tasks': { one: '{count} Aufgabe', other: '{count} Aufgaben' },
  // --- Add ---
  'boards.add.open': 'Aufgabe auf diesem Board hinzufügen oder erstellen',
  'boards.add.panel': 'Aufgabe hinzufügen oder erstellen',
  'boards.add.sharedHint':
    'Eine hier erstellte Aufgabe wird mit dem Personenkreis dieses Boards geteilt.',
  // --- Refine: filter and sort ---
  'boards.filter.placeholder': 'Dieses Board filtern…',
  'boards.sort.menu': 'Sortieren nach',
  'boards.sort.viewed': 'Zuletzt angesehen',
  'boards.sort.alpha': 'A–Z',
  'boards.sort.attention': 'Dringendste zuerst',
  // --- The empty board ---
  'boards.empty.title': 'Auf {board} liegt noch nichts',
  'boards.empty.curated':
    'Füge eine bestehende Aufgabe über die Suche hinzu oder erstelle eine: Was hier erstellt wird, wird hier hinzugefügt.',
  'boards.empty.scopeAudience':
    'Erstelle eine Aufgabe, füge eine bestehende hinzu oder gib Aufgaben für den Personenkreis dieses Boards frei, dann erscheinen sie hier.',
  'boards.empty.placeholder': 'Was ist zu tun?',
  // --- The suggestion lane ---
  'boards.suggest.strip': {
    one: '{count} Treffer · nicht hinzugefügt',
    other: '{count} Treffer · nicht hinzugefügt',
  },
  'boards.suggest.pin': 'Hinzufügen',
  'boards.suggest.cantAddTitle':
    'Du siehst das, aber um es hier hinzuzufügen, musst du die Aufgabe verwalten.',
  'boards.suggest.cantAdd': 'hier nicht hinzufügbar',
  // --- A lane ---
  'boards.lane.unset.flowPhase': 'Keine Phase',
  'boards.lane.unset.manual': 'Nicht zugeordnet',
  'boards.lane.unset.other': 'Ohne Wert',
  'boards.lane.expand': '{lane} aufklappen',
  'boards.lane.collapse': '{lane} einklappen',
  'boards.lane.means': 'bedeutet',
  'boards.lane.auto': 'automatisch · {means}',
  'boards.lane.about': 'Zur Spalte {lane}',
  'boards.lane.help':
    'Verschieben hierher setzt diese Werte, und eine Karte, die sie alle erreicht, wandert von selbst hierher: {means}. Eine Karte von Hand wegzuschieben löst nichts aus.',
  'boards.lane.add': 'Zu {lane} hinzufügen',
  'boards.lane.compose': 'Hinzufügen',
  'boards.lane.composePlaceholder': 'Titel der Aufgabe...',
  // --- A card ---
  'boards.card.parent': 'Übergeordnet · {title}',
  'boards.card.flag': 'Zustand von „{title}“ setzen',
  'boards.card.flagButton': 'Zustand von „{title}“ setzen (fertig, blockiert)',
  'boards.card.blocked': 'Blockiert',
  'boards.card.open': 'Öffnen',
  'boards.card.lensTitle': '{grade} - {provenance}',
  'boards.card.grade.notice': 'Hinweis',
  'boards.card.grade.warning': 'Warnung',
  'boards.card.grade.critical': 'kritisch',
  'boards.card.moreSignals': 'Weitere Signale: Öffne die Aufgabe',
  'boards.card.moreActions': 'Weitere Aktionen für „{title}“',
  'boards.card.openInNewTab': 'In neuem Tab öffnen',
  'boards.card.copyLink': 'Link kopieren',
  'boards.card.foldBack': 'Zurück in die übergeordnete Aufgabe',
  'boards.card.hide': 'Auf diesem Board ausblenden',
  'boards.card.unpin': 'Von diesem Board entfernen',
  'boards.card.pull': 'Aufs Board holen',
  'boards.card.pullItem': '„{title}“ aufs Board holen',
  'boards.card.showLess': 'Weniger anzeigen',
  'boards.card.more': '… {count} weitere',
  'boards.card.takeUpForGroup': 'Für die Gruppe annehmen',
  'boards.card.takeUp': 'Annehmen',
  'boards.card.decline': 'Ablehnen',
  'boards.card.verdictAsk': 'In Review: deine Review',
  'boards.card.accept': 'Annehmen',
  'boards.card.deny': 'Ablehnen',
  'boards.card.digestTitle':
    'Aussagen, die diese Aufgabe aus verknüpften Aufgaben erreichen (Abhängigkeiten und darunter): Öffne die Aufgabe, um sie bei ihren Beziehungen zu sehen',
  'boards.card.digest': '{count} aus verknüpften Aufgaben',
  // --- The hidden tray and the toasts ---
  'boards.hidden.count': '{count} ausgeblendet',
  'boards.hidden.unhide': 'Einblenden',
  'boards.toast.done': 'Fertig',
  'boards.toast.cancelled': 'Abgebrochen',
  'boards.toast.undo': 'Rückgängig',
  'boards.toast.asked': '{asked}: {statement}',
  // --- Configure ---
  'boards.config.open': 'Board einrichten',
  'boards.config.openTitle':
    'Dieses Board einrichten: was die Spalten bedeuten und mit welchem Ablauf es verknüpft ist',
  'boards.config.title': 'Board einrichten',
  'boards.config.cancel': 'Abbrechen',
  'boards.config.save': 'Speichern',
  'boards.config.board': 'Board',
  'boards.config.archive': 'Dieses Board archivieren',
  'boards.config.leave': 'Dieses Board verlassen',
  'boards.config.restore': 'Dieses Board wiederherstellen',
  'boards.config.belongs': 'Was darauf gehört',
  'boards.config.sourceLabel': 'Wie das Board gefüllt wird',
  'boards.config.source.curated': 'Nur Hinzugefügtes',
  'boards.config.source.scope': 'Alles Freigegebene',
  'boards.config.sourceHint.curated':
    'Nur Hinzugefügtes: Aufgaben kommen gezielt aufs Board, und eine hier erstellte Aufgabe wird hinzugefügt.',
  'boards.config.sourceHint.scope':
    'Alles, was für den Personenkreis dieses Boards freigegeben ist, dazu alles Hinzugefügte.',
  'boards.config.suggestions': 'Vorschläge',
  'boards.config.lensAbout': 'Zur angehängten Ansicht',
  'boards.config.lensHelp':
    'Eine angehängte Ansicht schlägt passende Aufgaben in einer ruhigen Spalte auf dem Board vor: Alle sehen ihre eigenen Treffer, und ein angenommener Vorschlag wird hinzugefügt (eine protokollierte Aktion). Eine Ansicht legt nie von selbst etwas aufs Board und gibt nie Zugriff auf etwas frei.',
  'boards.config.lensRetired': '{lens} (archiviert, schlägt nichts vor)',
  'boards.config.detach': 'Lösen',
  'boards.config.lensPick': 'Anzuhängende Ansicht',
  'boards.config.lensNone': 'Keine (keine Vorschläge)',
  'boards.config.attach': 'Anhängen',
  /** The Configure section that holds the kanban's own arrangement. */
  'boards.config.kanban': 'Kanban',
  'boards.config.lanes': 'Spalten',
  'boards.config.lanesHint.attribute':
    'Die Spalten sind die Werte des Merkmals; eine Karte zu verschieben setzt diesen Wert (protokolliert).',
  'boards.config.lanesHint.flowPhase':
    'Die Spalten sind die Phasen des verknüpften Ablaufs; eine Karte zu verschieben lässt die Aufgabe über ihre Schwellen vorrücken (protokolliert).',
  'boards.config.lanesHint.flowField':
    'Die Spalten sind die Werte des Ablauffelds; eine Karte zu verschieben setzt das Feld an der Aufgabe (protokolliert).',
  'boards.config.lanesHint.manual':
    'Die Spalten sind eine freie Einteilung nur auf diesem Board; eine Karte zu verschieben ändert nichts an der Aufgabe.',
  'boards.config.laneSource': 'Spalten nach',
  'boards.config.laneSource.flowPhase': 'Phasen des Ablaufs',
  'boards.config.laneSource.field': 'Feld: {field}',
  'boards.config.laneSource.manual': 'Manuelle Spalten',
  'boards.config.laneSource.attribute2': '{attribute} ({first} | {second})',
  'boards.config.laneSource.attribute3': '{attribute} ({first} | {second} | {third})',
  'boards.config.flow': 'Ablauf',
  'boards.config.flowAbout': 'Zur Verknüpfung mit dem Ablauf',
  'boards.config.flowHelp':
    'Ein Board bildet seine Spalten aus höchstens einem Ablauf: ein Verweis, kein Besitz; die Verknüpfung ändert nichts an den Aufgaben. Den Ablauf selbst (Phasen, Schwellen, Felder) bearbeitest du auf seiner eigenen Seite; hier kannst du jederzeit neu verknüpfen oder die Verknüpfung lösen.',
  'boards.config.flowArchived': '{flow} (archiviert)',
  'boards.config.flowPick': 'Verknüpfter Ablauf',
  'boards.config.flowNone': 'Keiner (kein Ablauf)',
  'boards.config.editFlow': 'Ablauf bearbeiten',
  'boards.config.createFlow': '+ Ablauf erstellen und verknüpfen',
  'boards.join.button': 'Aufgaben dieses Boards in {flow} aufnehmen',
  'boards.join.buttonUnnamed': 'Aufgaben dieses Boards in den Ablauf aufnehmen',
  'boards.join.joined': 'Aufgenommen: {count}',
  'boards.join.already': '{count} schon im Ablauf',
  'boards.join.skipped': '{count} übersprungen',
  'boards.join.hiddenTitle': 'Eine Aufgabe, die du sehen, aber nicht bearbeiten kannst',
  'boards.join.forbidden': 'dir fehlt das Recht, sie aufzunehmen',
  'boards.join.refused': 'der Ablauf hat die Aufnahme abgewiesen',
  'boards.config.manualLanes': 'Manuelle Spalten',
  'boards.config.laneName': 'Name der Spalte',
  'boards.config.laneDescription': 'Beschreibung (optional)',
  'boards.config.laneDescriptionLabel': 'Beschreibung der Spalte',
  'boards.config.removeLane': 'Spalte {lane} entfernen',
  'boards.config.addLane': '+ Spalte hinzufügen',
  'boards.config.rules': 'Zustandsregeln (nur dieses Board)',
  'boards.config.rulesAbout': 'Zu den Zustandsregeln',
  'boards.config.rulesHelp':
    'Trägt eine Karte hier einen Fakt, liest dieses Board ihn in der gewählten Stufe: Das färbt nur Karten auf diesem Board, wird nie an die Aufgabe geschrieben und ist sonst nirgends sichtbar. Hinweis ist leise, Warnung färbt und zählt, kritisch ist am lautesten; eine Board-Regel färbt nur und benachrichtigt nie jemanden. (Stufen im eigenen Katalog einer Gruppe benachrichtigen bei kritisch: Das wird im Katalog festgelegt, nicht auf einem Board.)',
  'boards.error.needsConfirmation':
    'Das braucht eine Bestätigung, nach der die Spalte nicht fragen kann.',
} as const satisfies AreaCatalog<typeof en>;
